import { PaymentGatewayIntegration } from "@/interfaces/payment-gateway-integrations/PaymentGatewayIntegration"
import { useAxios } from "./useAxios"
import { ref } from "vue"
import Cookies from "js-cookie";

const axios = useAxios()

export function usePaymentGatewayIntegration() {
  const organizationId = Cookies.get("organization") ? JSON.parse(Cookies.get("organization") ?? "null")?.id : process.env.VUE_APP_ORGANIZATION_ID;
  const paymentGatewayIntegration = ref<PaymentGatewayIntegration>(localStorage.getItem('paymentGatewayIntegration') ? JSON.parse(localStorage.getItem('paymentGatewayIntegration') as string) : null)

  const getOne = async (): Promise<PaymentGatewayIntegration> => {
    if (paymentGatewayIntegration.value && paymentGatewayIntegration.value?.organizationId === organizationId) {
      return paymentGatewayIntegration.value
    }

    const response = await axios.get(`/payment-gateway-integrations/me`)

    paymentGatewayIntegration.value = response.data
    localStorage.setItem('paymentGatewayIntegration', JSON.stringify(response.data))

    return response.data
  }

  const list = async (): Promise<any[]> => {
    const response = await axios.get(`/payment-gateway-integrations`)
    return response.data
  }

  // Envia os parâmetros de configuração (salva ou atualiza)
  const upsert = async (data: any) => {
    const response = await axios.put(`/payment-gateway-integrations`, data)
    return response.data
  }

  // Atualiza a ordenação das prioridades em lote (PATCH)
  const updatePriority = async (providers: string[]) => {
    const response = await axios.patch(`/payment-gateway-integrations/routing-priority`, { providers })
    return response.data
  }

  return {
    getOne,
    paymentGatewayIntegration,
    list,
    upsert,
    updatePriority
  }
}